import { cn } from "@/lib/utils";
import { Input, InputProps } from "@components/ui/input.tsx";
import { Search } from "lucide-react";

type SearchInputProps = InputProps & {
  wrapperClassName?: string;
  iconClassName?: string;
};

export default function SearchInput({
  className,
  wrapperClassName,
  iconClassName,
  ...props
}: SearchInputProps) {
  return (
    <div className={cn("relative h-9", wrapperClassName)}>
      <Search
        size={16}
        className={cn(
          "absolute left-2.5 top-1/2 -translate-y-1/2",
          "stroke-slate-500",
          iconClassName,
        )}
      />
      <Input className={cn("p-2 indent-6", className)} {...props} />
    </div>
  );
}
